import React from 'react';
import { Dropdown } from 'semantic-ui-react';
import PropTypes from 'prop-types';

import en from '../../styles/svgs/en.svg';
import hy from '../../styles/svgs/hy.svg';

import styles from './languageSelector.module.scss';
import { LANGUAGES } from '../../constants';

const flag = { en, hy };

const languages = [
  { name: 'english', key: 'en', label: 'Eng', src: en },
  { name: 'armenian', key: 'hy', label: 'Հայ', src: hy },
];

const LanguageSelector = ({ sideBarItem, selectedLanguage, onLanguageChange, withIcon }) => {
  const selectedLanguageLabel = languages.find((lang) => lang.key === selectedLanguage).label;

  const trigger = (
    <span>
      <img src={flag[selectedLanguage]} className={styles.dropdownFlag} alt="en" />
      {withIcon && (
        <>
          <span className={styles.language}>{selectedLanguageLabel}</span>
          <i className={`${styles.downIcon} `} />
        </>
      )}
    </span>
  );

  const options = languages.map((language) => ({
    key: language.key,
    value: language.key,
    content: (
      <span
        onClick={() => onLanguageChange(language.key)}
        className={styles.languageItem}
        role="presentation"
      >
        <img src={language.src} className={styles.dropdownFlag} alt={language.key} />
        <span className={styles.language}>{language.label}</span>
      </span>
    ),
  }));

  return (
    <>
      {!sideBarItem && (
        <Dropdown
          trigger={trigger}
          options={options}
          id={styles.languageContainer}
          defaultValue={selectedLanguage}
          direction="left"
        />
      )}

      {sideBarItem && (
        <>
          {sideBarItem === 'language' && (
            <img src={flag[selectedLanguage]} className={styles.flag} alt="flag" />
          )}

          {languages.map((language) => {
            if (sideBarItem !== language.name) return null;
            return (
              <div
                role="presentation"
                className={styles.flagWrapper}
                onClick={() => onLanguageChange(language.key)}
                key={language.name}
              >
                <img src={language.src} alt={language.key} className={styles.flag} />
              </div>
            );
          })}
        </>
      )}
    </>
  );
};

LanguageSelector.propTypes = {
  sideBarItem: PropTypes.string,
  onLanguageChange: PropTypes.func,
  selectedLanguage: PropTypes.oneOf([LANGUAGES.HY, LANGUAGES.EN]),
  withIcon: PropTypes.bool,
};

LanguageSelector.defaultProps = {
  sideBarItem: '',
  onLanguageChange: () => {},
  selectedLanguage: LANGUAGES.HY,
  withIcon: false,
};

export default LanguageSelector;
